// Imports
import { faCircle, faCircleNotch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import theme from '../../../../../../../shareables/theme';
import { setLightness, setSaturation } from 'polished';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import isScreenshot from '../../../../../../../shareables/utils/is-screenshot';


// Styled components
const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	margin: 1.25rem auto;
	gap: 0.5rem;
	
	h2 {
		color: #575757;
		font-size: 1.875rem;
		font-weight: 600;
		margin: 1.5625rem 0;
		line-height: 2.5rem;
	}
	
	> p {
		font-size: 1rem;
		font-weight: 300;
		text-align: center;
		margin: 0;
		padding: 0;
		line-height: normal;
	}
`;

const Wrapper = styled.div<{ isScreenshot: boolean }>`
	position: relative;
	
	.svg-inline--fa.fa-circle-notch {
		font-size: 7rem;
		color: ${setSaturation(0.48, setLightness(0.9, theme.colors.success))};
		animation: rotate 0.5s ease-in-out forwards;
	}
	
	.svg-inline--fa.fa-circle {
		font-size: 7rem;
		color: ${setSaturation(0.48, setLightness(0.9, theme.colors.success))};
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: ${(props) => (props.isScreenshot ? 1 : 0)};
		animation: fadeIn 0s ease-in-out 0.5s forwards;
	}
	
	.svg-inline--fa.fa-check {
		font-size: 4rem;
		color: ${theme.colors.success};
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: ${(props) => (props.isScreenshot ? 1 : 0)};
		animation: fadeIn 0.3s ease-in-out 0.5s forwards;
	}
	
	@keyframes rotate {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(390deg);
		}
	}
	
	@keyframes fadeOut {
		0% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
	
	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;


// Define the accepted props
interface Props {
	header: string;
	body: string | React.ReactElement;
}


// Function component
const FormSubmitted: React.FC<Props> = ({ header, body }) => {
	// Return JSX
	return (
		<Container>
			<Wrapper isScreenshot={isScreenshot()}>
				<FontAwesomeIcon icon={faCircleNotch} />
				<FontAwesomeIcon icon={faCircle} />
				<FontAwesomeIcon icon={faCheck} />
			</Wrapper>
			
			<h2>{header}</h2>
			<p>{body}</p>
		</Container>
	);
};

export default FormSubmitted;
